// @ts-nocheck
// ------------------------------------------------------------------------
// APIProtocol const
// ------------------------------------------------------------------------
const showLog = true
const HOST = 'localhost'
const PORT = '8900'
const PROTOCOL = 'http'
// ------------------------------------------------------------------------
// APIProtocol.LicenseConfig
// ------------------------------------------------------------------------
export class LicenseConfig {
  algorithm: string
  issuer: string
  subject: string
  x509: string

  public constructor() {
    this.algorithm = ''
    this.issuer = ''
    this.subject = ''
    this.x509 = ''
  }

  public set(json: any) {
    this.algorithm = json.algorithm
    this.issuer = json.issuer
    this.subject = json.subject
    this.x509 = json.x509
  }
}

// ------------------------------------------------------------------------
// APIProtocol.BackEndConfig
// ------------------------------------------------------------------------
export class BackEndConfig {
  backend: string
  productCode: string
  activationCode: string

  public constructor() {
    this.backend = ''
    this.productCode = ''
    this.activationCode = ''
  }

  public set(json: any) {
    this.backend = json.backend
    this.productCode = json.productCode
    this.activationCode = json.activationCode
  }
}

// ------------------------------------------------------------------------
// APIProtocol.WindowSetting
// ------------------------------------------------------------------------
export class WindowSetting {
  x: number
  y: number
  width: number
  height: number

  public constructor() {
    this.x = 0
    this.y = 0
    this.width = 0
    this.height = 0
  }

  public set(json: any) {
    this.x = json.x
    this.y = json.y
    this.width = json.width
    this.height = json.height
  }
}

// ------------------------------------------------------------------------
// APIProtocol.SettingConfig
// ------------------------------------------------------------------------
export class SettingConfig {
  locale: string
  diagnosis: boolean
  window: WindowSetting
  autoUpdate: boolean
  updateServer: string

  public constructor() {
    this.locale = ''
    this.diagnosis = false
    this.window = new WindowSetting()
    this.autoUpdate = false
    this.updateServer = ''
  }

  public set(json: any) {
    this.locale = json.locale
    this.diagnosis = json.diagnosis
    this.window.set(json.window)
    this.autoUpdate = json.autoUpdate
    this.updateServer = json.updateServer
  }
}

// ------------------------------------------------------------------------
// APIProtocol.LoggerFormat
// ------------------------------------------------------------------------
export class LoggerFormat {
  level: string
  timestamp: string

  public constructor() {
    this.level = 'info'
    this.timestamp = ''
  }

  public set(json: any) {
    this.level = json.level
    this.timestamp = json.timestamp
  }
}

// ------------------------------------------------------------------------
// APIProtocol.LoggerDailyRotate
// ------------------------------------------------------------------------
export class LoggerDailyRotate {
  enable: boolean
  dirname: string
  filename: string
  datePattern: string
  zippedArchive: boolean
  maxSize: string
  maxFiles: string

  public constructor() {
    this.enable = false
    this.dirname = ''
    this.filename = ''
    this.datePattern = ''
    this.zippedArchive = false
    this.maxSize = ''
    this.maxFiles = ''
  }

  public set(json: any) {
    this.enable = json.enable
    this.dirname = json.dirname
    this.filename = json.filename
    this.datePattern = json.datePattern
    this.zippedArchive = json.zippedArchive
    this.maxSize = json.maxSize
    this.maxFiles = json.maxFiles
  }
}

// ------------------------------------------------------------------------
// APIProtocol.LoggerConsole
// ------------------------------------------------------------------------
export class LoggerConsole {
  enable: boolean

  public constructor() {
    this.enable = false
  }

  public set(json: any) {
    this.enable = json.enable
  }
}

// ------------------------------------------------------------------------
// APIProtocol.LoggerConfig
// ------------------------------------------------------------------------
export class LoggerConfig {
  format: LoggerFormat
  dailyRotate: LoggerDailyRotate
  console: LoggerConsole

  public constructor() {
    this.format = new LoggerFormat()
    this.dailyRotate = new LoggerDailyRotate()
    this.console = new LoggerConsole()
  }

  public set(json: any) {
    this.format.set(json.format)
    this.dailyRotate.set(json.dailyRotate)
    this.console.set(json.console)
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Config
// ------------------------------------------------------------------------
export class Config {
  license: LicenseConfig
  backends: Array<BackEndConfig>
  setting: SettingConfig
  logger: LoggerConfig

  public constructor() {
    this.license = new LicenseConfig()
    this.backends = new Array<BackEndConfig>()
    this.setting = new SettingConfig()
    this.logger = new LoggerConfig()
  }

  public set(input: any) {
    if (showLog) {
      console.log('Config.set():ENTER')
    }
    const json = JSON.parse(input)
    if (showLog) {
      console.log('Config.set():json=', json)
    }
    if (showLog) {
      console.log('Config.set():license=', json.license)
    }
    this.license.set(json['license'])
    for (let i = 0; i < json.backends.length; i++) {
      const item = new BackEndConfig()
      item.set(json.backends[i])
      this.backends.push(item)
    }
    this.setting.set(json.setting)
    this.logger.set(json.logger)
    if (showLog) {
      console.log('Config.set():LEAVE')
    }
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Service
// ------------------------------------------------------------------------
export class Service {
  index: number
  enable: boolean
  name: string
  type: string
  startedAt: Date
  updatedAt: Date
  status: string
  error: string
  setting: string

  constructor() {
    this.index = 0
    this.enable = false
    this.name = ''
    this.type = ''
    this.startedAt = new Date()
    this.updatedAt = new Date()
    this.status = 'Unknown'
    this.error = ''
    this.setting = ''
  }

  public set(json: any) {
    this.index = json.index
    this.enable = json.enable
    this.name = json.name
    this.type = json.type
    this.startedAt = json.startedAt
    this.updatedAt = json.updatedAt
    this.status = json.status
    this.error = json.error
    this.setting = json.setting
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Version
// ------------------------------------------------------------------------
export interface Version {
  major: number
  minor: number
}

// ------------------------------------------------------------------------
// APIProtocol.SlotInfo
// ------------------------------------------------------------------------
export interface SlotInfo {
  // ----------------------------------------------------------------------
  // Character-string description of the slot
  // ----------------------------------------------------------------------
  slotDescription: string
  // ----------------------------------------------------------------------
  // ID of the slot manufacturer
  // ----------------------------------------------------------------------
  manufacturerID: string
  // ----------------------------------------------------------------------
  // Bits flags that provide capabilities of the slot
  // ----------------------------------------------------------------------
  flags: number
  // ----------------------------------------------------------------------
  // Version number of the slot's hardware
  // ----------------------------------------------------------------------
  hardwareVersion: Version
  // ----------------------------------------------------------------------
  // Version number of the slot's firmware
  // ----------------------------------------------------------------------
  firmwareVersion: Version
}

// ------------------------------------------------------------------------
// APIProtocol.TokenInfo
// ------------------------------------------------------------------------
export interface TokenInfo {
  // ----------------------------------------------------------------------
  // Application-defined label, assigned during token initialization
  // ----------------------------------------------------------------------
  label: string
  // ----------------------------------------------------------------------
  // ID of the device manufacturer
  // ----------------------------------------------------------------------
  manufacturerID: string
  // ----------------------------------------------------------------------
  // Model of the device
  // ----------------------------------------------------------------------
  model: string
  // ----------------------------------------------------------------------
  // Character-string serial number of the device.
  // ----------------------------------------------------------------------
  serialNumber: string
  // ----------------------------------------------------------------------
  // Bit flags indicating capabilities and status of the device
  // ----------------------------------------------------------------------
  flags: number
  // ----------------------------------------------------------------------
  // Maximum number of sessions that can be opened with the token at one
  // time by a single application
  // ----------------------------------------------------------------------
  maxSessionCount: number
  // ----------------------------------------------------------------------
  // Number of sessions that this application currently has open with the
  // token
  // ----------------------------------------------------------------------
  sessionCount: number
  // ----------------------------------------------------------------------
  // maximum number of read/write sessions that can be opened
  // with the token at one time by a single application
  // ----------------------------------------------------------------------
  maxRwSessionCount: number
  // ----------------------------------------------------------------------
  // Number of read/write sessions that this application currently has open
  // with the token
  // ----------------------------------------------------------------------
  rwSessionCount: number
  // ----------------------------------------------------------------------
  // Maximum length in bytes of the PIN
  // ----------------------------------------------------------------------
  maxPinLen: number
  // ----------------------------------------------------------------------
  // Minimum length in bytes of the PIN
  // ----------------------------------------------------------------------
  minPinLen: number
  // ----------------------------------------------------------------------
  // The total amount of memory on the token in bytes in which public
  // objects may be stored
  // ----------------------------------------------------------------------
  totalPublicMemory: number
  // ----------------------------------------------------------------------
  // The amount of free (unused) memory on the token in bytes for public
  // objects
  // ----------------------------------------------------------------------
  freePublicMemory: number
  // ----------------------------------------------------------------------
  // The total amount of memory on the token in bytes in which private
  // objects may be stored
  // ----------------------------------------------------------------------
  totalPrivateMemory: number
  // ----------------------------------------------------------------------
  // The amount of free (unused) memory on the token in bytes for private
  // objects
  // ----------------------------------------------------------------------
  freePrivateMemory: number
  // ----------------------------------------------------------------------
  // Version number of hardware
  // ----------------------------------------------------------------------
  hardwareVersion: Version
  // ----------------------------------------------------------------------
  // Version number of firmware
  // ----------------------------------------------------------------------
  firmwareVersion: Version
  // ----------------------------------------------------------------------
  // Current time. Null when a token does not have a clock.
  // ----------------------------------------------------------------------
  utcTime: Date | null
}

// ------------------------------------------------------------------------
// APIProtocol.Mechanism
// ------------------------------------------------------------------------
export interface Mechanism {
  name: string
  flags: number
  maxKeySize: number
  minKeySize: number
}

// ------------------------------------------------------------------------
// MechanismInfoFlag : bit flags specifying Token mechanism capabilities..
// ------------------------------------------------------------------------
export enum MechanismInfoFlag {
  HW = 0x00000001, // CKF_HW
  ENCRYPT = 0x00000100, // CKF_ENCRYPT
  DECRYPT = 0x00000200, // CKF_DECRYPT
  DIGEST = 0x00000400, // CKF_DIGEST
  SIGN = 0x00000800, // CKF_SIGN
  SIGN_RECOVER = 0x00001000, // CKF_SIGN_RECOVER
  VERIFY = 0x00002000, // CKF_VERIFY
  VERIFY_RECOVER = 0x00004000, // CKF_VERIFY_RECOVER
  GENERATE = 0x00008000, // CKF_GENERATE
  GENERATE_KEY_PAIR = 0x00010000, // CKF_GENERATE_KEY_PAIR
  WRAP = 0x00020000, // CKF_WRAP
  UNWRAP = 0x00040000 // CKF_UNWRAP
}

// ------------------------------------------------------------------------
// APIProtocol.KeyStore
// ------------------------------------------------------------------------
export class KeyStore {
  constructor(
    public id?: string,
    public name?: string,
    public icon?: string,
    public type?: string,
    public enable?: boolean,
    public available?: boolean,
    public status?: string,
    public friendlyName?: string,
    public path?: string,
    public library?: string,
    public slot?: number,
    public slotCount?: number,
    public availableSlots?: number,
    public removable?: boolean,
    public readWrite?: boolean,
    public keyStoreId?: string,
    public keyStoreFriendlyName?: string,
    public keyStoreType?: string,
    public keyStorePath?: string,
    public info?: string
  ) {}

  public set(json: any) {
    this.id = json.id
    this.name = json.name
    this.icon = json.icon
    this.type = json.type
    this.friendlyName = json.friendlyName
    this.path = json.path
    this.enable = json.enable
    this.available = json.available
    this.status = json.status
    this.slot = json.slot
    this.slotCount = json.slotCount
    this.availableSlots = json.availableSlots
    this.removable = json.removable
    this.readWrite = json.readWrite
    this.keyStoreId = json.id
    this.keyStoreFriendlyName = json.friendlyName
    this.keyStoreType = json.type
    this.keyStorePath = json.path
    this.library = json.library
    this.info = json.info
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Token
// ------------------------------------------------------------------------
export class Token {
  constructor(
    public id?: string,
    public name?: string,
    public icon?: string,
    public type?: string,
    public enable?: boolean,
    public available?: boolean,
    public status?: string,
    public friendlyName?: string,
    public path?: string,
    public library?: string,
    public slot?: number,
    public removable?: boolean,
    public readWrite?: boolean,
    public keyStoreId?: string,
    public keyStoreFriendlyName?: string,
    public keyStoreType?: string,
    public keyStorePath?: string,
    public info?: string,
    public slotInfo?: SlotInfo,
    public tokenInfo?: TokenInfo,
    public mechanism?: Array<Mechanism>
  ) {}

  public set(json: any) {
    this.id = json.id
    this.name = json.name
    this.icon = json.icon
    this.type = json.type
    this.friendlyName = json.friendlyName
    this.path = json.path
    this.enable = json.enable
    this.available = json.available
    this.status = json.status
    this.slot = json.slot
    this.removable = json.removable
    this.readWrite = json.readWrite
    this.keyStoreId = json.id
    this.keyStoreFriendlyName = json.friendlyName
    this.keyStoreType = json.type
    this.keyStorePath = json.path
    this.library = json.library
    this.info = json.info
    this.slotInfo = json.slotInfo
    this.tokenInfo = json.tokenInfo
    this.mechanism = json.mechanism
  }

  // ----------------------------------------------------------------------
  // Token.getAvailableKeyTypes();
  // ----------------------------------------------------------------------
  public getAvailableKeyTypes(): Array<any> {
    const result = new Array<any>()
    for (let i = 0; i < this.mechanism?.length; i++) {
      const item = this.mechanism[i]
      if (item.name === 'RSA_PKCS_KEY_PAIR_GEN') {
        result.push({ keyType: 'RSA', maxKeySize: item.maxKeySize, minKeySize: item.minKeySize })
      }
      if (item.name === 'EC_KEY_PAIR_GEN') {
        result.push({ keyType: 'ECDSA', maxKeySize: item.maxKeySize, minKeySize: item.minKeySize })
      }
    }
    return result
  }

  // ----------------------------------------------------------------------
  // Token.getAvailableKeyType();
  // ----------------------------------------------------------------------
  public getAvailableKeyType(type: string): any | null {
    for (let i = 0; i < this.mechanism?.length; i++) {
      const item = this.mechanism[i]
      if (type === 'RSA') {
        if (item.name === 'RSA_PKCS_KEY_PAIR_GEN') {
          return { maxKeySize: item.maxKeySize, minKeySize: item.minKeySize }
        }
      }
      if (type === 'ECDSA') {
        if (item.name === 'EC_KEY_PAIR_GEN') {
          return { maxKeySize: item.maxKeySize, minKeySize: item.minKeySize }
        }
      }
    }
    return null
  }
  // ----------------------------------------------------------------------
  // Token.getAvailableHashAlgo();
  // ----------------------------------------------------------------------
  public getAvailableHashAlgo(type: string): Array<string> {
    const result = new Array<any>()
    for (let i = 0; i < this.mechanism?.length; i++) {
      const item = this.mechanism[i]
      // filter signing algo based on CKF_SIGN flag..
      if (item.flags & MechanismInfoFlag.DIGEST) {
        if (item.name === 'SHA_1') {
          result.push('SHA1')
        }
        if (item.name === 'SHA256') {
          result.push('SHA256')
        }
        if (item.name === 'SHA384') {
          result.push('SHA384')
        }
        if (item.name === 'SHA512') {
          result.push('SHA512')
        }
      }
    }
    return result
  }

  // ----------------------------------------------------------------------
  // Token.getAvailableSignAlgo();
  // ----------------------------------------------------------------------
  public getAvailableSignAlgo(type: string): Array<string> {
    const result = new Array<any>()
    for (let i = 0; i < this.mechanism?.length; i++) {
      const item = this.mechanism[i]
      // filter signing algo based on CKF_SIGN flag..
      if (item.flags & MechanismInfoFlag.SIGN) {
        if (type === 'RSA') {
          switch (item.name) {
            case 'SHA1_RSA_PKCS':
            case 'SHA224_RSA_PKCS':
            case 'SHA256_RSA_PKCS':
            case 'SHA384_RSA_PKCS':
            case 'SHA512_RSA_PKCS':
              if (!result.includes('RSAPKCS')) {
                result.push('RSAPKCS')
              }
              break
            case 'SHA1_RSA_PKCS_PSS':
            case 'SHA224_RSA_PKCS_PSS':
            case 'SHA256_RSA_PKCS_PSS':
            case 'SHA384_RSA_PKCS_PSS':
            case 'SHA512_RSA_PKCS_PSS':
              if (!result.includes('RSAPSS')) {
                result.push('RSAPSS')
              }
              break
            default:
              break
          }
        }
        if (type === 'ECDSA') {
          switch (item.name) {
            case 'ECDSA_SHA1':
            case 'ECDSA_SHA256':
            case 'ECDSA_SHA384':
            case 'ECDSA_SHA512':
              if (!result.includes('ECDSA')) {
                result.push('ECDSA')
              }
              break
            default:
              break
          }
        }
      }
    }
    return result
  }
  // ----------------------------------------------------------------------
  // Token.getSignAlgoName();
  // ----------------------------------------------------------------------
  public getSignAlgoName(hashAlgo: string, signAlgo: string): string {
    switch (signAlgo) {
      case 'RSAPKCS':
        switch (hashAlgo) {
          case 'SHA1':
            return 'sha1WithRsaEncryption'
          case 'SHA256':
            return 'sha256WithRsaEncryption'
          case 'SHA384':
            return 'sha384WithRsaEncryption'
          case 'SHA512':
            return 'sha512WithRsaEncryption'
          default:
            break
        }
        break
      case 'RSAPSS':
        switch (hashAlgo) {
          case 'SHA1':
            return 'sha1WithRSASSAPSS'
          case 'SHA256':
            return 'sha256WithRSASSAPSS'
          case 'SHA384':
            return 'sha384WithRSASSAPSS'
          case 'SHA512':
            return 'sha512WithRSASSAPSS'
          default:
            break
        }
        break
      case 'ECDSA':
        switch (hashAlgo) {
          case 'SHA1':
            return 'ecdsaWithSha1'
          case 'SHA256':
            return 'ecdsaWithSha256'
          case 'SHA384':
            return 'ecdsaWithSha384'
          case 'SHA512':
            return 'ecdsaWithSha512'
          default:
            break
        }
        break
      default:
        break
    }
    return ''
  }

  // ----------------------------------------------------------------------
  // Token.getSignFormatName();
  // ----------------------------------------------------------------------
  public getSignFormatName(signAlgo: string): string {
    let result = ''
    switch (signAlgo) {
      case 'RSAPKCS':
        result = 'RSASSA-PKCS1-v1_5'
        break
      case 'RSAPSS':
        result = 'RSASSA-PSS'
        break
      case 'ECDSA':
        result = 'ECDSA'
        break
      default:
        break
    }
    return result
  }

  // ----------------------------------------------------------------------
  // Token.getAvailableSignatureAlgo();
  // ----------------------------------------------------------------------
  public getAvailableSignatureAlgo(type: string): Array<string> {
    const result = new Array<any>()
    for (let i = 0; i < this.mechanism?.length; i++) {
      const item = this.mechanism[i]
      // filter signing algo based on CKF_SIGN flag..
      if (item.flags & MechanismInfoFlag.SIGN) {
        if (type === 'RSA') {
          if (item.name === 'SHA1_RSA_PKCS') {
            result.push('SHA1_RSA_PKCS')
          }
          if (item.name === 'SHA256_RSA_PKCS') {
            result.push('SHA256_RSA_PKCS')
          }
          if (item.name === 'SHA384_RSA_PKCS') {
            result.push('SHA384_RSA_PKCS')
          }
          if (item.name === 'SHA512_RSA_PKCS') {
            result.push('SHA512_RSA_PKCS')
          }
          if (item.name === 'SHA1_RSA_PKCS_PSS') {
            result.push('SHA1_RSA_PKCS_PSS')
          }
          if (item.name === 'SHA256_RSA_PKCS_PSS') {
            result.push('SHA256_RSA_PKCS_PSS')
          }
          if (item.name === 'SHA384_RSA_PKCS') {
            result.push('SHA384_RSA_PKCS_PSS')
          }
          if (item.name === 'SHA512_RSA_PKCS') {
            result.push('SHA512_RSA_PKCS_PSS')
          }
        }
        if (type === 'ECDSA') {
          if (item.name === 'ECDSA_SHA1') {
            result.push('ECDSA_SHA1')
          }
          if (item.name === 'ECDSA_SHA256') {
            result.push('ECDSA_SHA256')
          }
          if (item.name === 'ECDSA_SHA384') {
            result.push('ECDSA_SHA384')
          }
          if (item.name === 'ECDSA_SHA512') {
            result.push('ECDSA_SHA512')
          }
        }
      }
    }
    return result
  }

  public getMinKeySize(type: string) {
    let target = ''
    let result = 0
    if (type === 'RSA') {
      target = 'RSA_PKCS_KEY_PAIR_GEN'
    }
    if (type === 'ECC') {
      target = 'EC_KEY_PAIR_GEN'
    }
    for (let i = 0; i < this.mechanism.length; i++) {
      if (target === this.mechanism[i].name) {
        result = this.mechanism[i].minKeySize
        break
      }
    }
    return result
  }

  public getMaxKeySize(type: string) {
    let target = ''
    let result = 0
    if (type === 'RSA') {
      target = 'RSA_PKCS_KEY_PAIR_GEN'
    }
    if (type === 'ECC') {
      target = 'EC_KEY_PAIR_GEN'
    }
    for (let i = 0; i < this.mechanism.length; i++) {
      if (target === this.mechanism[i].name) {
        result = this.mechanism[i].maxKeySize
        break
      }
    }
    return result
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Key
// ------------------------------------------------------------------------
export interface Key {
  index: number
  id: string
  name: string
  type: string
  pem: string
}

// ------------------------------------------------------------------------
// APIProtocol.Certificate
// ------------------------------------------------------------------------
export class Certificate {
  constructor(
    public index?: number,
    public id?: string,
    public tokenId?: string,
    public keyStoreId?: string,
    public keyStorePath?: string,
    public keyStoreFriendlyName?: string,
    public keyStoreType?: string,
    public subject?: Map<string, Array<string>>,
    public issuer?: Map<string, Array<string>>,
    public serial?: string,
    public notBefore?: string,
    public notAfter?: string,
    public signatureAlgorithm?: string,
    public subjectPublicKeyInfo?: string,
    public pem?: string,
    public privateKey?: boolean,
    public isCA?: boolean,
    public isSelfSigned?: boolean,
    public keyType?: string,
    public publicKey?: {}
  ) {}

  public Certificate() {}

  public set(json: any) {
    this.index = json.index
    this.id = json.id
    this.tokenId = json.tokenId
    this.keyStoreId = json.keyStoreId
    this.keyStorePath = json.keyStorePath
    this.keyStoreFriendlyName = json.keyStoreFriendlyName
    this.keyStoreType = json.keyStoreType
    this.issuer = new Map(JSON.parse(json.issuer))
    this.subject = new Map(JSON.parse(json.subject))
    this.serial = json.serial
    this.notBefore = json.notBefore
    this.notAfter = json.notAfter
    this.signatureAlgorithm = json.signatureAlgorithm
    this.subjectPublicKeyInfo = json.subjectPublicKeyInfo
    this.pem = json.pem
    this.privateKey = json.privateKey
    this.isCA = json.isCA
    this.isSelfSigned = json.isSelfSigned
    this.keyType = json.keyType
    this.publicKey = json.publicKey
  }
}

// ------------------------------------------------------------------------
// APIProtocol.BackupFile
// ------------------------------------------------------------------------
class BackupFile {
  constructor(public success: boolean, public filename: string, public base64: string, public error: string) {}
  public BackupFile() {}
}

// ------------------------------------------------------------------------
// APIProtocol.APIRequestEnvelope
// ------------------------------------------------------------------------
export class APIRequestEnvelope {
  id: string
  nonce: string
  created: string
  algorithm: string
  payload: string

  constructor() {
    this.id = Utils.uuidv4()
    this.nonce = Utils.generateRandomBase64(64)
    this.created = new Date().toISOString()
    this.algorithm = 'UNKNOWN'
    this.payload = ''
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APIResponseEnvelope
// ------------------------------------------------------------------------
export class APIResponseEnvelope {
  id: string
  nonce: string
  created: string
  algorithm: string
  payload: string

  constructor() {
    this.id = Utils.uuidv4()
    this.nonce = Utils.generateRandomBase64(64)
    this.created = new Date().toISOString()
    this.algorithm = 'UNKNOWN'
    this.payload = ''
  }

  set(json: any) {
    this.id = json.id
    this.nonce = json.nonce
    this.algorithm = json.algorithm
    this.payload = json.payload
  }

  public static create(json: any) {
    const result = new APIResponseEnvelope()
    result.set(json)
    return result
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APIRequest
// ------------------------------------------------------------------------
export class APIRequest {
  host: string
  port: string
  protocol: string
  command: string
  path: string
  method: string
  body: string
  created: Date

  constructor(path: string) {
    this.host = HOST
    this.port = PORT
    this.protocol = PROTOCOL
    this.command = ''
    this.path = path
    this.method = 'GET'
    this.body = ''
    this.created = new Date()
  }

  public static create(method: string, protocol: string, path: string) {
    const result = new APIRequest(path)
    result.method = method
    result.protocol = protocol
    return result
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APIResponse
// ------------------------------------------------------------------------
export class APIResponse {
  host: string
  port: string
  protocol: string
  path: string
  method: string
  statusCode: number
  url: string
  body: string
  error: string
  created: Date

  constructor() {
    this.host = HOST
    this.port = PORT
    this.protocol = PROTOCOL
    this.path = ''
    this.method = 'GET'
    this.statusCode = 0
    this.url = ''
    this.body = ''
    this.error = ''
    this.created = new Date()
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APIResult
// ------------------------------------------------------------------------
export interface APIResult {
  success: boolean
  error: string
}

// ------------------------------------------------------------------------
// APIProtocol.APIException
// ------------------------------------------------------------------------
export class APIException {
  what: string
  where: string
  code: number
  time: Date

  constructor(where: string, what: string, code: number) {
    this.where = where
    this.what = what
    this.code = code
    this.time = new Date()
  }
}

// ------------------------------------------------------------------------
// APIProtocol.Utils
// ------------------------------------------------------------------------
class Utils {
  // ----------------------------------------------------------------------
  // Utils.now():
  // ----------------------------------------------------------------------
  public static uuidv4() {
    const chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case 'x':
          chars[i] = Math.floor(Math.random() * 16).toString(16)
          break
        case 'y':
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
          break
      }
    }
    return chars.join('')
  }

  // ----------------------------------------------------------------------
  // Utils.now():
  // ----------------------------------------------------------------------
  public static now() {
    return new Date().toISOString()
  }

  // ----------------------------------------------------------------------
  // Utils.generateRandom()
  // ----------------------------------------------------------------------
  public static generateRandom(length: number) {
    const uintarray = window.crypto.getRandomValues(new Uint8Array(length))
    return uintarray
  }

  // ----------------------------------------------------------------------
  // Utils.generateRandomBase64()
  // ----------------------------------------------------------------------
  public static generateRandomBase64(length: number) {
    const uintarray = window.crypto.getRandomValues(new Uint8Array(length))
    return this.arrayBufferToBase64(uintarray)
  }

  // ----------------------------------------------------------------------
  // Utils.base64ToArray()
  // ----------------------------------------------------------------------
  public static base64ToArray(base64: string) {
    return Uint8Array.from(atob(base64), c => c.charCodeAt(0))
  }

  // ----------------------------------------------------------------------
  // Utils.arrayBufferToBase64():
  // ----------------------------------------------------------------------
  public static arrayBufferToBase64(buffer: ArrayBuffer): string {
    let result = ''
    const bytes = new Uint8Array(buffer)
    const len = bytes.byteLength
    for (let i = 0; i < len; i++) {
      result += String.fromCharCode(bytes[i])
    }
    return btoa(result)
  }

  // ----------------------------------------------------------------------
  // Utils.concatArrayBuffer():
  // ----------------------------------------------------------------------
  public static concatArrayBuffer(a: Uint8Array, b: Uint8Array) {
    const c = new Uint8Array(a.byteLength + b.byteLength)
    c.set(new Uint8Array(a), 0)
    c.set(new Uint8Array(b), a.byteLength)
    return c.buffer
  }

  // ----------------------------------------------------------------------
  // Utils.concatUint8Array():
  // ----------------------------------------------------------------------
  public static concatUint8Array(a: Uint8Array, b: Uint8Array) {
    const c = new Uint8Array(a.byteLength + b.byteLength)
    c.set(new Uint8Array(a), 0)
    c.set(new Uint8Array(b), a.byteLength)
    return c
  }

  // ----------------------------------------------------------------------
  // Utils.sha256():
  // ----------------------------------------------------------------------
  public static async sha256(data: Uint8Array) {
    const temp = await crypto.subtle.digest('SHA-256', data)
    return new Uint8Array(temp)
  }

  // ----------------------------------------------------------------------
  // Utils.removeHeader():
  // ----------------------------------------------------------------------
  public static removeHeader(str: string) {
    let result = str
    if (str) {
      let pem = str
      pem = pem.replace('-----BEGIN CERTIFICATE REQUEST-----', '')
      pem = pem.replace('-----END CERTIFICATE REQUEST-----', '')
      pem = pem.replace('-----BEGIN ENCRYPTED PRIVATE KEY-----', '')
      pem = pem.replace('-----END ENCRYPTED PRIVATE KEY-----', '')
      pem = pem.replace('-----BEGIN PRIVATE KEY-----', '')
      pem = pem.replace('-----END PRIVATE KEY-----', '')
      pem = pem.replace('-----BEGIN PUBLIC KEY-----', '')
      pem = pem.replace('-----END PUBLIC KEY-----', '')
      pem = pem.replace('-----BEGIN CERTIFICATE-----', '')
      pem = pem.replace('-----END CERTIFICATE-----', '')
      pem = pem.replace(/^\n/gm, '')
      pem = pem.replace(/^\r/gm, '')
      result = pem
    }
    return result
  }

  // ----------------------------------------------------------------------
  // Utils.toMaskedString():
  // ----------------------------------------------------------------------
  public static toMaskedString(str: string | undefined) {
    let result = ''
    if (str !== undefined) {
      for (let i = 0; i < str.length; i++) {
        result += '*'
      }
    }
    return result
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APISession
// ------------------------------------------------------------------------
class APISession {
  licenseCode: string
  id: string
  nonce: string
  status: string
  clientKeyPair: CryptoKeyPair | null
  clientECDHKey: JsonWebKey | null
  serverDHKey: string
  sharedSecretKey: CryptoKey | null
  clientEncryptKey: CryptoKey | null
  serverDecryptKey: CryptoKey | null

  constructor() {
    this.licenseCode = ''
    this.id = ''
    this.nonce = Utils.generateRandomBase64(64)
    this.status = 'UNINITIALIZED'
    this.clientKeyPair = null
    this.clientECDHKey = null
    this.serverDHKey = ''
    this.sharedSecretKey = null
    this.clientEncryptKey = null
    this.serverDecryptKey = null
  }

  // ----------------------------------------------------------------------
  // APISession.handshakeRequest()
  // ----------------------------------------------------------------------
  public async handshakeRequest(): Promise<string> {
    // console.debug("APISession.handshakeRequest():ENTER");
    let result = ''
    try {
      const message = { created: Utils.now(), algorithm: 'ECDH', dhkey: {} }
      // ------------------------------------------------------------------
      // 1) Generate DHKeyPair
      // ------------------------------------------------------------------
      // console.debug("APISession.handshakeRequest():1) Generate DHKeyPair");
      const dhKeyPair = await window.crypto.subtle.generateKey(
        {
          name: 'ECDH',
          namedCurve: 'P-256'
        },
        false,
        ['deriveKey', 'deriveBits']
      )
      this.clientKeyPair = dhKeyPair
      // ------------------------------------------------------------------
      // 2) Export DHPublicKey as spki (pem)
      // ------------------------------------------------------------------
      // console.debug("APISession.handshakeRequest():2) Export DHPublicKey");
      const dhPubKey = await window.crypto.subtle.exportKey('spki', dhKeyPair.publicKey)
      const pem = Utils.removeHeader(Utils.arrayBufferToBase64(dhPubKey))
      // console.debug("APISession.handshakeRequest():dhKeyPair=", pem);
      message.dhkey = { type: 'spki', pem: pem }
      // ------------------------------------------------------------------
      // 3) Sign the publicKey by private Key (Skipped)
      // ------------------------------------------------------------------
      // ==================================================================
      // Note: The folloing step cannot be done, because key.algorithm does
      // not match that of operation (due to usage of ECDH Key in webcrypt)
      // ==================================================================
      // if (showLog) { console.log("APISession.handshakeRequest():3) Sign the publicKey"); }
      // const signature = await window.crypto.subtle.sign(
      //  {
      //    name: "ECDSA",
      //    hash: {name: "SHA-256"},
      //  },
      //  dhKeyPair.privateKey,
      //  dhPubKey
      // );
      // result.signature = Utils.arrayBufferToBase64(signature);
      // if (showLog) { console.log("APISession.handshakeRequest():Signature="+result.signature); }

      // ------------------------------------------------------------------
      // 4) Generate SharedSecretKey of HKDF by Nonce
      // ------------------------------------------------------------------
      // console.debug("APISession.handshakeRequest():4) Generate Secret");
      // Server (Trust Assistant): HKDF-Extract (Nonce + SHA256(Nonce), “server-psk”)
      // Client (JavaScript SDK):  HKDF-Extract (Nonce + SHA256(Nonce), “client-psk“)
      const nonce = Utils.base64ToArray(this.nonce)
      const hash = await Utils.sha256(nonce)
      // console.debug("APISession.handshakeRequest():hash=" + Utils.arrayBufferToBase64(hash));
      const sharedSecret = Utils.concatUint8Array(nonce, hash)
      // console.debug("APISession.handshakeRequest():PSK(IN)=" + Utils.arrayBufferToBase64(sharedSecret));

      const preSharedSecretKey = await window.crypto.subtle.importKey(
        'raw',
        sharedSecret,
        {
          name: 'HKDF'
        },
        false,
        ['deriveKey', 'deriveBits']
      )
      // ------------------------------------------------------------------
      // 5) Generate Client PSK(Pre-Shared Key) by Fixed Info
      // ------------------------------------------------------------------
      // console.debug("APISession.handshakeRequest():5) Derive SecretKey by PSK");
      const salt = hash
      const info = new TextEncoder().encode('client-psk')
      const derivedKey = await window.crypto.subtle.deriveKey(
        {
          name: 'HKDF',
          hash: 'SHA-256',
          info: info,
          salt: salt
        },
        preSharedSecretKey,
        {
          name: 'AES-GCM',
          length: 256
        },
        true,
        ['encrypt', 'decrypt']
      )
      // console.debug("APISession.handshakeRequest():derivedKey=", derivedKey);
      const encjwk = await window.crypto.subtle.exportKey('jwk', derivedKey)
      // console.debug("APISession.handshakeRequest():encjwk=", encjwk);

      // ------------------------------------------------------------------
      // 6) Encrypt Payload
      // ------------------------------------------------------------------
      // console.debug("APISession.handshakeRequest():6) Encrypt Payload");
      const payload = JSON.stringify(message)
      // console.debug("APISession.handshakeRequest():payload=", payload);
      const data = new TextEncoder().encode(payload)
      const iv = Utils.generateRandom(16)
      const encrypted = await window.crypto.subtle.encrypt(
        {
          name: 'AES-GCM',
          iv: iv,
          additionalData: nonce,
          tagLength: 128
        },
        derivedKey,
        data
      )
      const buff = Utils.concatArrayBuffer(iv, new Uint8Array(encrypted))
      result = Utils.arrayBufferToBase64(buff)
      // console.debug("APISession.handshakeRequest():encrypted=" + result);
    } catch (e) {
      console.error('APISession.handshake():Caught Exception=', e)
    }
    console.debug('APISession.handshakeRequest():LEAVE')
    return result
  }

  // ----------------------------------------------------------------------
  // APISession.exchangeKey()
  // ----------------------------------------------------------------------
  public async exchangeKey(json: any) {
    // console.debug("APISession.exchangeKey():ENTER");
    // console.debug("APISession.exchangeKey():input=", json);
    try {
      // ------------------------------------------------------------------
      // 1)
      // ------------------------------------------------------------------
      const nonce = Utils.base64ToArray(json.nonce)
      // console.debug("APISession.exchangeKey():nonce=" + json.nonce);
      const hash = await Utils.sha256(nonce)
      // console.debug("APISession.exchangeKey():hash=" + Utils.arrayBufferToBase64(hash));
      const secret = Utils.concatUint8Array(nonce, hash)
      // console.debug("APISession.exchangeKey():secret=" + Utils.arrayBufferToBase64(secret));
      const psk = await window.crypto.subtle.importKey(
        'raw',
        secret,
        {
          name: 'HKDF'
        },
        false,
        ['deriveKey', 'deriveBits']
      )
      // console.debug("APISession.exchangeKey():importKey=", psk);
      const salt = hash
      const info = new TextEncoder().encode('server-psk')
      const derivedKey = await window.crypto.subtle.deriveKey(
        {
          name: 'HKDF',
          hash: 'SHA-256',
          info: info,
          salt: salt
        },
        psk,
        {
          name: 'AES-GCM',
          length: 256
        },
        true,
        ['encrypt', 'decrypt']
      )
      // console.debug("APISession.exchangeKey():derivedKey=", derivedKey);
      const encjwk = await window.crypto.subtle.exportKey('jwk', derivedKey)
      // console.debug("APISession.exchangeKey():encjwk=", encjwk);

      const raw = Utils.base64ToArray(json.payload)
      // console.debug("APISession.exchangeKey():payload=", json.payload);
      const iv = new Uint8Array(raw.slice(0, 16))
      // console.debug("APISession.exchangeKey():iv=" + Utils.arrayBufferToBase64(iv));
      const encrypted = raw.slice(16)
      const tag = new Uint8Array(raw.slice(raw.byteLength - 16))
      // if (showLog) { console.log("APISession.exchangeKey():tag=" + Utils.arrayBufferToBase64(tag)); }
      const decrypted = await window.crypto.subtle.decrypt(
        {
          name: 'AES-GCM',
          iv: iv,
          additionalData: nonce,
          tagLength: 128
        },
        derivedKey,
        encrypted
      )
      // console.debug("APISession.exchangeKey():decrypted=", decrypted);
      const temp = decrypted.slice(decrypted.byteLength - 16)
      const decoder = new TextDecoder('utf-8')
      const cleartext = decoder.decode(decrypted)
      // console.debug("APISession.exchangeKey():cleartext=", cleartext);
      const payload = JSON.parse(cleartext)
      // console.debug("APISession.exchangeKey():payload=", payload);
      // ------------------------------------------------------------------
      // 1) Get DHPublic Key
      // ------------------------------------------------------------------
      // console.debug("APISession.exchangeKey():json.dhkey.pem=" + payload.dhkey.pem);
      const buffer = Utils.base64ToArray(payload.dhkey.pem)
      // console.debug("APISession.exchangeKey():buffer=", buffer);
      const dhServerPubKey = await window.crypto.subtle.importKey(
        'spki',
        buffer,
        {
          name: 'ECDH',
          namedCurve: 'P-256'
        },
        true,
        []
      )
      // console.debug("APISession.exchangeKey():dhServerPubKey=", dhServerPubKey);
      // ------------------------------------------------------------------
      // 2) Generate SecretKey
      // ------------------------------------------------------------------
      if (this.clientKeyPair) {
        // ----------------------------------------------------------------
        // 2.1) Compute SharedSecret
        // ----------------------------------------------------------------
        const sharedSecret = await window.crypto.subtle.deriveBits(
          { name: 'ECDH', public: dhServerPubKey },
          this.clientKeyPair.privateKey,
          256
        )
        const sharedSecretB64 = Utils.arrayBufferToBase64(sharedSecret)
        // console.debug("APISession.exchangeKey():sharedSecret=" + sharedSecretB64);
        // ----------------------------------------------------------------
        // 2.2) Derive SecretKey by SharedSecret
        // ----------------------------------------------------------------
        const sharedSecretKey = await window.crypto.subtle.importKey(
          'raw',
          sharedSecret,
          {
            name: 'HKDF',
            hash: 'SHA-256'
          },
          false,
          ['deriveKey', 'deriveBits']
        )
        // ----------------------------------------------------------------
        // 2.3) Derive EncryptKey through HKDF by SharedSecret
        // ----------------------------------------------------------------
        // HKDF-Extract(Nonce + TransactionId + SHA256(“Master Secret”))
        // console.debug("APISession.exchangeKey():client-encrypt(sessionId)=" + json.sessionId);
        if (sharedSecretKey) {
          const tid = new TextEncoder().encode(json.sessionId)
          const temp = Utils.concatUint8Array(nonce, tid)
          const mshs = await Utils.sha256(new Uint8Array(sharedSecret))
          const salt = Utils.concatUint8Array(temp, mshs)
          // console.debug("APISession.exchangeKey():client-encrypt(tid)=" + Utils.arrayBufferToBase64(tid));
          // console.debug("APISession.exchangeKey():client-encrypt(nonce)=" + Utils.arrayBufferToBase64(nonce));
          // console.debug("APISession.exchangeKey():client-encrypt(mshs)=" + Utils.arrayBufferToBase64(mshs));
          // console.debug("APISession.exchangeKey():client-encrypt(salt)=" + Utils.arrayBufferToBase64(salt));
          const clientEncryptKey = await window.crypto.subtle.deriveKey(
            {
              name: 'HKDF',
              hash: { name: 'SHA-256' },
              salt: salt,
              info: new TextEncoder().encode('client-encrypt')
            },
            sharedSecretKey,
            {
              name: 'AES-GCM',
              length: 256
            },
            true,
            ['encrypt', 'decrypt']
          )
          // console.debug("APISession.exchangeKey():client-encrypt=", clientEncryptKey);
          const encjwk = await window.crypto.subtle.exportKey('jwk', clientEncryptKey)
          // console.debug("APISession.exchangeKey():client-encrypt=", encjwk);
          this.clientEncryptKey = clientEncryptKey

          const serverDecryptKey = await window.crypto.subtle.deriveKey(
            {
              name: 'HKDF',
              hash: { name: 'SHA-256' },
              salt: salt,
              info: new TextEncoder().encode('server-encrypt')
            },
            sharedSecretKey,
            {
              name: 'AES-GCM',
              length: 256
            },
            true,
            ['encrypt', 'decrypt']
          )
          // console.debug("APISession.exchangeKey():client-encrypt=", serverDecryptKey);
          const ssjwk = await window.crypto.subtle.exportKey('jwk', serverDecryptKey)
          // console.debug("APISession.exchangeKey():client-encrypt=", ssjwk);
          this.clientEncryptKey = clientEncryptKey
          this.serverDecryptKey = serverDecryptKey
        }
        this.id = json.sessionId
        this.sharedSecretKey = sharedSecretKey
      }
    } catch (e) {
      console.error('APISession.exchangeKey():Caught Exception=', e)
    }
    // if (showLog) { console.log("APISession.exchangeKey():LEAVE"); }
  }

  // ----------------------------------------------------------------------
  // APISession.encrypt()
  // ----------------------------------------------------------------------
  public async encrypt(nonce: string, raw: string) {
    // if (showLog) { console.log("APISession.encrypt():ENTER"); }
    // console.debug("APISession.encrypt():nonce=" + nonce);
    // console.debug("APISession.encrypt():raw=" + raw);
    const result = { success: false, encrypted: '' }
    if (this.clientEncryptKey) {
      try {
        const iv = Utils.generateRandom(16)
        // if (showLog) { console.log("APISession.encrypt():iv=" + Utils.arrayBufferToBase64(iv)); }
        const data = new TextEncoder().encode(raw)
        const encrypted = await window.crypto.subtle.encrypt(
          {
            name: 'AES-GCM',
            iv: iv,
            additionalData: Utils.base64ToArray(nonce),
            tagLength: 128
          },
          this.clientEncryptKey,
          data
        )
        const buff = Utils.concatArrayBuffer(iv, new Uint8Array(encrypted))
        result.success = true
        result.encrypted = Utils.arrayBufferToBase64(buff)
        // console.debug("APISession.encrypt():encrypted=" + Utils.arrayBufferToBase64(encrypted));
      } catch (e) {
        console.error('APISession.encrypt():Caught Exception=', e)
      }
    }
    // if (showLog) { console.log("APISession.encrypt():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // APISession.decrypt()
  // ----------------------------------------------------------------------
  public async decrypt(nonce: string, data: string) {
    // console.debug("APISession.decrypt():ENTER");
    // console.debug("APISession.decrypt():nonce=" + nonce);
    // console.debug("APISession.decrypt():data=" + data);
    const result = { success: false, decrypted: '' }
    if (this.serverDecryptKey) {
      try {
        const aead = Utils.base64ToArray(nonce)
        const raw = Utils.base64ToArray(data)
        // console.debug("APISession.decrypt():raw=" + Utils.arrayBufferToBase64(raw));
        const iv = raw.slice(0, 16)
        // console.debug("APISession.decrypt():iv=" + Utils.arrayBufferToBase64(iv));
        const encrypted = raw.slice(16)
        // console.debug("APISession.decrypt():encrypted=" + Utils.arrayBufferToBase64(encrypted));
        const decrypted = await window.crypto.subtle.decrypt(
          {
            name: 'AES-GCM',
            iv: iv,
            additionalData: aead,
            tagLength: 128 //The tagLength you used to encrypt (if any)
          },
          this.serverDecryptKey,
          encrypted
        )
        const temp = decrypted.slice(decrypted.byteLength - 16)
        const decoder = new TextDecoder('utf-8')
        const cleartext = decoder.decode(decrypted)
        // console.debug("APISession.decrypt():cleartext=", cleartext);
        result.success = true
        result.decrypted = cleartext
        // console.debug("APISession.decrypt():decrypted=", decrypted);
      } catch (e) {
        console.error('APISession.decrypt():Caught Exception=', e)
      }
    }
    console.debug('APISession.decrypt():LEAVE')
    return result
  }
}

// ------------------------------------------------------------------------
// APIProtocol.APIClient
// ------------------------------------------------------------------------
export class APIClient {
  // ----------------------------------------------------------------------
  // Version of APIClient
  // ----------------------------------------------------------------------
  public static version = '1.0.0'
  // ----------------------------------------------------------------------
  // members
  // ----------------------------------------------------------------------
  private session: APISession
  protocol: string
  clientVersion: string

  // ----------------------------------------------------------------------
  // hidden constructor
  // ----------------------------------------------------------------------
  private constructor() {
    this.session = new APISession()
    this.protocol = 'http'
    this.clientVersion = 'UNKNOWN'
  }

  // ----------------------------------------------------------------------
  // APIClient.isInstalled()
  // ----------------------------------------------------------------------
  //  ARG[0]: timeoutMs (number) - time in milliseconds to wait until dialog
  //    appears until returning false
  //  RETURN: Promise<boolean> -
  //    if already running, returns true
  //    if not running but installed, will open a dialog to allow opening
  //      the app, and returns true
  //    otherwise false
  // ----------------------------------------------------------------------
  public static async isInstalled(timeoutMs: number = 2000): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.isInstalled():ENTER')
    }
    let result = false
    if (await new APIClient().isRunning()) {
      if (showLog) {
        console.log('APIClient.isInstalled():is running')
      }
      result = true
    } else {
      result = await CustomUrlChecker.openProtocol('dctrustassistant://open', timeoutMs)
    }
    if (showLog) {
      console.log('APIClient.isInstalled():result=' + result)
    }
    if (showLog) {
      console.log('APIClient.isInstalled():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // public: APIClient.create()
  // ----------------------------------------------------------------------
  //  ARG[0]: licenseCode (string (JWS))
  //  ARG[1]: timeoutMs (number) - if already installed, timeout in
  //    milliseconds to wait until user clicks the allow opening the app
  //  RETURN: APIClient class
  // ----------------------------------------------------------------------
  public static async create(licenseCode: string, timeoutMs: number = 30000): Promise<APIClient> {
    const client = new APIClient()
    // --------------------------------------------------------------------
    // ERROR-CODE:
    // --------------------------------------------------------------------
    const WHERE = 'APIClient.create()'
    const ERR_NOT_INSTALLED = 1
    const ERR_NOT_RUNNING = 2
    const ERR_HANDSHAKE_FAILED = 3
    const ERR_INITIALIZE_FAILED = 4
    // --------------------------------------------------------------------
    //
    // --------------------------------------------------------------------
    if (!(await client.isRunning())) {
      const isInstalled = await CustomUrlChecker.openProtocol('dctrustassistant://open')

      if (!isInstalled) {
        const error = 'Trust Assistant is not installed'
        throw new APIException(WHERE, error, ERR_NOT_INSTALLED)
      }
      // If installed, wait for timeoutMs until user clicks the allow opening
      // app and becomes running
      let timedOut = false
      setTimeout(() => (timedOut = true), timeoutMs)
      while (!timedOut) {
        const delay = (n: number) => new Promise(r => setTimeout(r, n))
        await delay(2000)
        if (await client.isRunning()) {
          break
        }
      }
      if (timedOut) {
        const error = 'Trust Assistant is not running'
        throw new APIException(WHERE, error, ERR_NOT_RUNNING)
      }
    }

    let ret = await client.handshake()
    if (ret) {
      if (!ret.success) {
        const error = 'Failed to handshake'
        throw new APIException(WHERE, error, ERR_HANDSHAKE_FAILED)
      }
    }

    ret = await client.initialize(licenseCode)
    if (ret) {
      if (!ret.success) {
        const error = 'Failed to initialize'
        throw new APIException(WHERE, ret?.error || error, ERR_INITIALIZE_FAILED)
      }
    }

    return client
  }

  // ----------------------------------------------------------------------
  // APIClient.handshake()
  // ----------------------------------------------------------------------
  private async handshake() {
    // if (showLog) { console.log("APIClient.handshake():ENTER"); }
    const result = { success: false, error: '', sessionId: '' }
    const path = '/api/v1/handshake'
    const request = APIRequest.create('POST', this.protocol, path)
    // -----------------------------------------------------------------
    // Generate Request Envelope
    // -----------------------------------------------------------------
    const envelope = new APIRequestEnvelope()
    envelope.nonce = this.session.nonce
    envelope.algorithm = 'AES256-GCM'
    envelope.payload = await this.session.handshakeRequest()
    request.body = JSON.stringify(envelope)
    // if (showLog) { console.log("APIClient.handshake():request=", request); }
    const response = await this.execute(request)
    // if (showLog) { console.log("APIClient.handshake():response=", response); }
    const json = JSON.parse(response.body)
    // if (showLog) { console.log("APIClient.handshake():json=", json); }
    if (json) {
      const ret = await this.session.exchangeKey(json)
      result.success = true
      result.sessionId = json.sessionId
    }
    // if (showLog) { console.log("APIClient.handshake():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.initialize(licenseCode: string)
  // ----------------------------------------------------------------------
  private async initialize(licenseCode: string): Promise<any> {
    // if (showLog) { console.log("APIClient.initialize():ENTER"); }
    // if (showLog) { console.log("APIClient.initialize():licenseCode=" + licenseCode); }
    const result = { success: false, error: '', version: '', sessionId: '', clientVersion: '' }
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/initialize',
      parameter: {
        licenseCode: licenseCode
      }
    }
    request.body = JSON.stringify(payload)
    // console.debug("APIClient.initialize():request=", request);
    const response = await this.transmit(request)
    // console.debug("APIClient.initialize():response=", response);
    const json = JSON.parse(response.body)
    if (json.success) {
      // if (showLog) { console.log("APIClient.initialize():sessionId=" + json.sessionId); }
      // if (showLog) { console.log("APIClient.initialize():clientVersion=" + json.clientVersion); }
      result.success = true
      result.version = APIClient.version
      result.sessionId = json.sessionId
      result.clientVersion = json.clientVersion
      this.session.status = 'INITIALIZED'
      this.clientVersion = json.clientVersion
    } else {
      result.error = json.error
      console.error('APIClient.initialize():Error=' + result.error)
    }
    // if (showLog) { console.log("APIClient.initialize():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getClientVersion():
  // ----------------------------------------------------------------------
  //  RETURN: string (eg, "1.0.0")
  // ----------------------------------------------------------------------
  public static async GetClientVersion(): Promise<string> {
    const client = new APIClient()
    const json = await client.hello()
    if (json['success'] && json['status'] === 'up') {
      return json['clientVersion']
    }
    return this.clientVersion
  }

  public async hello(): Promise<any> {
    const request = APIRequest.create('GET', this.protocol, '/api/v1/hello')
    const response = await this.execute(request)
    const json: any = response.body
    return json
  }

  // ----------------------------------------------------------------------
  // APIClient.isRunning()
  // ----------------------------------------------------------------------
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async isRunning(): Promise<boolean> {
    // if (showLog) { console.log("APIClient.isRunning():ENTER"); }
    let result = false
    const request = APIRequest.create('GET', this.protocol, '/api/v1/hello')
    // if (showLog) { console.log("APIClient.isRunning():request=", request); }
    const response = await this.execute(request)
    // if (showLog) { console.log("APIClient.isRunning():response=", response); }
    const json: any = response.body
    if (json['success'] && json['status'] === 'up') {
      result = true
    }
    // if (showLog) { console.log("APIClient.isRunning():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.isEnabled()
  // ----------------------------------------------------------------------
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async isEnabled(): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.isEnabled():ENTER')
    }
    if (showLog) {
      console.log('APIClient.isEnabled():LEAVE')
    }
    return true
  }

  // ----------------------------------------------------------------------
  // APIClient.getServices()
  // ----------------------------------------------------------------------
  //  RETURN: List of Service classes
  // ----------------------------------------------------------------------
  public async getServices(): Promise<Array<Service>> {
    if (showLog) {
      console.log('APIClient.getServices():ENTER')
    }
    const WHERE = 'APIClient.getServices()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/service'
    }
    console.debug('APIClient.getServices():payload=', payload)
    request.body = JSON.stringify(payload)
    console.debug('APIClient.getServices():request=', request)
    const response = await this.transmit(request)
    console.debug('APIClient.getServices():response=', response)
    const json = JSON.parse(response.body)
    const result = new Array<Service>()
    console.debug('APIClient.getServices():json=', json)
    if (json.success) {
      console.debug('APIClient.getServices():Success:', json)
      const services = json.services
      for (let i = 0; i < services.length; i++) {
        const service = new Service()
        service.set(services[i])
        result.push(service)
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getServices():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getCertificates()
  // ----------------------------------------------------------------------
  //  RETURN: List of Certificate classes
  // ----------------------------------------------------------------------
  public async getCertificates(): Promise<Array<Certificate>> {
    if (showLog) {
      console.log('APIClient.getCertificates():ENTER')
    }
    const WHERE = 'APIClient.getCertificates()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/certificate'
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.getCertificates():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.getCertificates():response=', response)
    }
    const json = JSON.parse(response.body)
    const result = new Array<Certificate>()
    if (showLog) {
      console.log('APIClient.getCertificates():json=', json)
    }
    if (json.success) {
      const certs = json.certificates
      if (certs) {
        console.debug('APIClient.getCertificates():certs=', certs)
        for (let i = 0; i < certs.length; i++) {
          const cert = new Certificate()
          console.debug('APIClient.getCertificates():certs[' + i + ']=', certs[i])
          cert.set(certs[i])
          result.push(cert)
        }
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getCertificates():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getConfig()
  // ----------------------------------------------------------------------
  //  RETURN: Config class
  // ----------------------------------------------------------------------
  public async getConfig(): Promise<Config> {
    if (showLog) {
      console.log('APIClient.getConfig():ENTER')
    }
    const result = new Config()
    const WHERE = 'APIClient.getConfig()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/config'
    }
    if (showLog) {
      console.log('APIClient.getConfig():request=', request)
    }
    request.body = JSON.stringify(payload)
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.getConfig():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      const config = json.config
      if (showLog) {
        console.log('APIClient.getConfig():json=', json)
      }
      result.set(config)
      if (showLog) {
        console.log('APIClient.getConfig():setting=', result)
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getConfig():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.setConfig()
  // ----------------------------------------------------------------------
  //  ARG[0]: config (Config class)
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async setConfig(config: Config): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.setConfig():ENTER')
    }
    if (showLog) {
      console.log('APIClient.setConfig():ARG[0]:config=', config)
    }
    let result = false
    const WHERE = 'APIClient.setConfig()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/config',
      parameter: {
        config: config
      }
    }
    if (showLog) {
      console.log('APIClient.setConfig():request=', request)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.setConfig():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.setConfig():response=', response)
    }
    const json = JSON.parse(response.body)
    if (showLog) {
      console.log('APIClient.setConfig():json=', json)
    }
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.setConfig():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.generate()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: format ["PKCS10"]
  //  ARG[2]: keyType ["RSASSA-PKCS1-v1_5","ECDSA"]
  //  ARG[3]: keySize ['2048','3072','4096','256','384','521']
  //  ARG[4]: sigAlgo ['sha256WithRsaEncryption','ecdsaWithSha256']
  //  ARG[5]: extractable(boolean)
  //  ARG[6]: options (any)
  //  RETURN: CSR (base64)
  // ----------------------------------------------------------------------
  public async generate(
    tokenId: string,
    format: string,
    keyType: string,
    keySize: string,
    sigAlgo: string,
    extractable: boolean,
    options: {}
  ): Promise<string> {
    if (showLog) {
      console.log('APIClient.generate():ENTER')
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[1]:format=' + format)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[2]:keyType=' + keyType)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[3]:keySize=' + keySize)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[4]:sigAlgo=' + sigAlgo)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[5]:extractable=' + extractable)
    }
    if (showLog) {
      console.log('APIClient.generate():ARG[6]:options=' + options)
    }
    let result = ''
    const WHERE = 'APIClient.generate()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/generate',
      parameter: {
        tokenId: tokenId,
        format: format,
        keyType: keyType,
        keySize: keySize,
        sigAlgo: sigAlgo,
        extractable: extractable,
        options: options
      }
    }
    if (showLog) {
      console.log('APIClient.generate():payload=', payload)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.generate():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.generate():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      result = json.csr
    } else {
      if (showLog) {
        console.log('APIClient.generate():json=', json)
      }
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.generate():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getKeyStores()
  // ----------------------------------------------------------------------
  //  RETURN: List of KeyStore classes
  // ----------------------------------------------------------------------
  public async getKeyStores(): Promise<Array<KeyStore>> {
    if (showLog) {
      console.log('APIClient.getKeyStores():ENTER')
    }
    const WHERE = 'APIClient.getKeyStores()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/keystore'
    }
    if (showLog) {
      console.log('APIClient.getKeyStores():request=', request)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.getKeyStores():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.getKeyStores():response=', response)
    }
    const json = JSON.parse(response.body)
    const result = new Array<KeyStore>()
    if (json.success) {
      if (showLog) {
        console.log('APIClient.getKeyStores():json=', json)
      }
      const keystores = json.keystores
      if (showLog) {
        console.log('APIClient.getKeyStores():keystore=', keystores)
      }
      for (let i = 0; i < keystores.length; i++) {
        const keystore = new KeyStore()
        keystore.set(keystores[i])
        result.push(keystore)
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getKeyStores():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getTokens()
  // ----------------------------------------------------------------------
  //  RETURN: List of Token classes
  // ----------------------------------------------------------------------
  public async getTokens(): Promise<Array<Token>> {
    if (showLog) {
      console.log('APIClient.getTokens():ENTER')
    }
    const WHERE = 'APIClient.getTokens()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/token'
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.getTokens():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.getTokens():response=', response)
    }
    const json = JSON.parse(response.body)
    const result = new Array<Token>()
    if (json.success) {
      const tokens = json.tokens
      for (let i = 0; i < tokens.length; i++) {
        const token = new Token()
        token.set(tokens[i])
        result.push(token)
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getTokens():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.getToken()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  RETURN: Token class
  // ----------------------------------------------------------------------
  public async getToken(tokenId: string): Promise<Token> {
    if (showLog) {
      console.log('APIClient.getToken():ENTER')
    }
    if (showLog) {
      console.log('APIClient.getToken():ARG[0]:tokenId=' + tokenId)
    }
    const token = new Token()
    const WHERE = 'APIClient.getToken()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/token',
      parameter: {
        tokenId: tokenId
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.getToken():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.getToken():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      if (showLog) {
        console.log('APIClient.getToken():json=', json)
      }
      const tokens = json.tokens
      if (tokens.length > 0) {
        token.set(tokens[0])
        if (showLog) {
          console.log('APIClient.getToken():token=', token)
        }
      }
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.getToken():LEAVE')
    }
    return token
  }

  // ----------------------------------------------------------------------
  // APIClient.changePIN()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: pin
  //  ARG[2]: newPin
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async changePIN(tokenId: string, pin: string, newPin: string): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.changePIN():ENTER')
    }
    if (showLog) {
      console.log('APIClient.changePIN():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.changePIN():ARG[1]:pin=' + Utils.toMaskedString(pin))
    }
    if (showLog) {
      console.log('APIClient.changePIN():ARG[2]:newPin=' + Utils.toMaskedString(newPin))
    }
    let result = false
    const WHERE = 'APIClient.changePIN()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/changepin',
      parameter: {
        tokenId: tokenId,
        pin: pin,
        newPin: newPin
      }
    }
    if (showLog) {
      console.log('APIClient.changePIN():request=', request)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.changePIN():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.changePIN():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.changePIN():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.verifyPIN()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: pin
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async verifyPIN(tokenId: string, pin: string): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.verifyPIN():ENTER')
    }
    if (showLog) {
      console.log('APIClient.verifyPIN():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.verifyPIN():ARG[1]:pin=' + Utils.toMaskedString(pin))
    }
    let result = false
    const WHERE = 'APIClient.verifyPIN()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/verifypin',
      parameter: {
        tokenId: tokenId,
        pin: pin
      }
    }
    if (showLog) {
      console.log('APIClient.verifyPIN():payload=', payload)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.verifyPIN():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.verifyPIN():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.verifyPIN():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.resetPIN()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: sopin
  //  ARG[2]: pin
  //  ARG[3]: label
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async resetPIN(tokenId: string, sopin: string, pin: string, label: string): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.resetPIN():ENTER')
    }
    if (showLog) {
      console.log('APIClient.resetPIN():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.resetPIN():ARG[1]:sopin=' + Utils.toMaskedString(sopin))
    }
    if (showLog) {
      console.log('APIClient.resetPIN():ARG[2]:pin=' + Utils.toMaskedString(pin))
    }
    if (showLog) {
      console.log('APIClient.resetPIN():ARG[3]:label=' + label)
    }
    let result = false
    const WHERE = 'APIClient.resetPIN()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/resetpin',
      parameter: {
        tokenId: tokenId,
        sopin: sopin,
        pin: pin,
        label: label
      }
    }
    if (showLog) {
      console.log('APIClient.resetPIN():payload=', payload)
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.resetPIN():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.resetPIN():response.body=', response.body)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.resetPIN():response=', response)
    }
    if (showLog) {
      console.log('APIClient.resetPIN():LEAVE')
    }
    return result
  }


  // ----------------------------------------------------------------------
  // APIClient.backupToken()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: sopin
  //  ARG[2]: pin
  //  ARG[3]: label
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async backupToken(tokenId: string, sopin: string, pin: string, pswd: string): Promise<BackupFile> {
    console.log('APIClient.backupToken():ENTER')
    console.log('APIClient.backupToken():ARG[0]:tokenId=' + tokenId)
    console.log('APIClient.backupToken():ARG[1]:sopin=' + Utils.toMaskedString(sopin))
    console.log('APIClient.backupToken():ARG[2]:pin=' + Utils.toMaskedString(pin))
    console.log('APIClient.backupToken():ARG[3]:pswd=' + Utils.toMaskedString(pswd))
    const result = new BackupFile(false, '', '', '')
    const WHERE = 'APIClient.backupToken()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/backupToken',
      parameter: {
        tokenId: tokenId,
        sopin: sopin,
        pin: pin,
        pswd: pswd
      }
    }
    console.log('APIClient.backupToken():payload=', payload)
    request.body = JSON.stringify(payload)
    console.log('APIClient.backupToken():request=', request)
    const response = await this.transmit(request)
    console.log('APIClient.backupToken():response.body=', response.body)
    const json = JSON.parse(response.body)
    if (json.success) {
      result.success = true
      result.filename = json.filename
      result.base64 = json.base64
      result.error = json.error
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    console.log('APIClient.backupToken():response=', response)
    console.log('APIClient.backupToken():LEAVE')
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.restoreToken()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: base64
  //  ARG[2]: sopin
  //  ARG[3]: pin
  //  ARG[4]: pswd
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async restoreToken(tokenId: string, base64: string, sopin: string, pin: string, pswd: string, archive: boolean): Promise<boolean> {
    console.log('APIClient.restoreToken():ENTER')
    console.log('APIClient.restoreToken():ARG[0]:tokenId=' + tokenId)
    console.log('APIClient.restoreToken():ARG[1]:base64=' + base64)
    console.log('APIClient.restoreToken():ARG[2]:sopin=' + Utils.toMaskedString(sopin))
    console.log('APIClient.restoreToken():ARG[3]:pin=' + Utils.toMaskedString(pin))
    console.log('APIClient.restoreToken():ARG[4]:pswd=' + Utils.toMaskedString(pswd))
    console.log('APIClient.restoreToken():ARG[5]:archive=' + archive)
    let result = false
    const WHERE = 'APIClient.restoreToken()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/restoreToken',
      parameter: {
        tokenId: tokenId,
        base64: base64,
        sopin: sopin,
        pin: pin,
        pswd: pswd,
        archive: archive
      }
    }
    console.log('APIClient.restoreToken():payload=', payload)
    request.body = JSON.stringify(payload)
    console.log('APIClient.restoreToken():request=', request)
    const response = await this.transmit(request)
    console.log('APIClient.restoreToken():response.body=', response.body)
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    console.log('APIClient.restoreToken():response=', response)
    console.log('APIClient.restoreToken():LEAVE')
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.registerProvider()
  // ----------------------------------------------------------------------
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async registerProvider(option: string): Promise<boolean> {
    console.log('APIClient.registerProvider():ENTER')
    console.log('APIClient.registerProvider():ARG[0]:option=' + option)
    let result = false
    const WHERE = 'APIClient.registerProvider()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/registerProvider',
      parameter: {
        option: option
      }
    }
    console.log('APIClient.registerProvider():payload=', payload)
    request.body = JSON.stringify(payload)
    console.log('APIClient.registerProvider():request=', request)
    const response = await this.transmit(request)
    console.log('APIClient.registerProvider():response.body=', response.body)
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    console.log('APIClient.registerProvider():response=', response)
    console.log('APIClient.registerProvider():LEAVE')
    return result
  }

   // ----------------------------------------------------------------------
    // APIClient.initToken()
    // ----------------------------------------------------------------------
    //  ARG[0]: tokenId
    //  ARG[1]: sopin
    //  ARG[2]: pin
    //  ARG[3]: label
    //  RETURN: boolean
    // ----------------------------------------------------------------------
    public async initToken(tokenId: string, sopin: string, pin: string, label: string): Promise<boolean> {
      console.log('APIClient.initToken():ENTER')
      console.log('APIClient.initToken():ARG[0]:tokenId=' + tokenId)
      console.log('APIClient.initToken():ARG[1]:sopin=' + Utils.toMaskedString(sopin))
      console.log('APIClient.initToken():ARG[2]:pin=' + Utils.toMaskedString(pin))
      console.log('APIClient.initToken():ARG[3]:label=' + label)
      let result = false
      const WHERE = 'APIClient.initToken()'
      const path = '/api/v1/request'
      const request = APIRequest.create('POST', this.protocol, path)
      const payload = {
        command: '/api/v1/initToken',
        parameter: {
          tokenId: tokenId,
          sopin: sopin,
          pin: pin,
          label: label
        }
      }
      console.log('APIClient.initToken():payload=', payload)
      request.body = JSON.stringify(payload)
      console.log('APIClient.initToken():request=', request)
      const response = await this.transmit(request)
      console.log('APIClient.initToken():response.body=', response.body)
      const json = JSON.parse(response.body)
      if (json.success) {
        result = true
      } else {
        throw new APIException(WHERE, json.error, 1)
      }
      console.log('APIClient.initToken():response=', response)
      console.log('APIClient.initToken():LEAVE')
      return result
    }


  // ----------------------------------------------------------------------
  // APIClient.initToken()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: sopin
  //  ARG[2]: pin
  //  ARG[3]: label
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async initToken(tokenId: string, sopin: string, pin: string, label: string): Promise<boolean> {
    console.log('APIClient.initToken():ENTER')
    console.log('APIClient.initToken():ARG[0]:tokenId=' + tokenId)
    console.log('APIClient.initToken():ARG[1]:sopin=' + Utils.toMaskedString(sopin))
    console.log('APIClient.initToken():ARG[2]:pin=' + Utils.toMaskedString(pin))
    console.log('APIClient.initToken():ARG[3]:label=' + label)
    let result = false
    const WHERE = 'APIClient.initToken()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/initToken',
      parameter: {
        tokenId: tokenId,
        sopin: sopin,
        pin: pin,
        label: label
      }
    }
    console.log('APIClient.initToken():payload=', payload)
    request.body = JSON.stringify(payload)
    console.log('APIClient.initToken():request=', request)
    const response = await this.transmit(request)
    console.log('APIClient.initToken():response.body=', response.body)
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    console.log('APIClient.initToken():response=', response)
    console.log('APIClient.initToken():LEAVE')
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.initToken()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: sopin
  //  ARG[2]: pin
  //  ARG[3]: label
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async initToken(tokenId: string, sopin: string, pin: string, label: string): Promise<boolean> {
    console.log('APIClient.initToken():ENTER')
    console.log('APIClient.initToken():ARG[0]:tokenId=' + tokenId)
    console.log('APIClient.initToken():ARG[1]:sopin=' + Utils.toMaskedString(sopin))
    console.log('APIClient.initToken():ARG[2]:pin=' + Utils.toMaskedString(pin))
    console.log('APIClient.initToken():ARG[3]:label=' + label)
    let result = false
    const WHERE = 'APIClient.initToken()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/initToken',
      parameter: {
        tokenId: tokenId,
        sopin: sopin,
        pin: pin,
        label: label
      }
    }
    console.log('APIClient.initToken():payload=', payload)
    request.body = JSON.stringify(payload)
    console.log('APIClient.initToken():request=', request)
    const response = await this.transmit(request)
    console.log('APIClient.initToken():response.body=', response.body)
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    console.log('APIClient.initToken():response=', response)
    console.log('APIClient.initToken():LEAVE')
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.sign()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: certId
  //  ARG[2]: sigAlgo ['sha256WithRsaEncryption','ecdsaWithSha256']
  //  ARG[3]: format ['RSA','ECDSA']
  //  ARG[4]: base64 (data for sign)
  //  RETURN: APIClient class
  // ----------------------------------------------------------------------
  public async sign(tokenId: string, certId: string, sigAlgo: string, format: string, base64: string): Promise<any> {
    if (showLog) {
      console.log('APIClient.sign():ENTER')
    }
    if (showLog) {
      console.log('APIClient.sign():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.sign():ARG[1]:certId=' + certId)
    }
    if (showLog) {
      console.log('APIClient.sign():ARG[2]:sigAlgo=' + sigAlgo)
    }
    if (showLog) {
      console.log('APIClient.sign():ARG[3]:format=' + format)
    }
    if (showLog) {
      console.log('APIClient.sign():ARG[4]:base64=' + base64)
    }
    const result = { success: false, error: '', datab64: '' }
    const WHERE = 'APIClient.sign()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/sign',
      parameter: {
        tokenId: tokenId,
        certId: certId,
        format: format,
        sigAlgo: sigAlgo,
        datab64: base64
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.sign():request=', request)
    }
    const response = await this.transmit(request)
    const json = JSON.parse(response.body)
    if (showLog) {
      console.log('APIClient.sign():response=', json)
    }
    if (json.success) {
      console.log('success')
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.sign():LEAVE')
    }
    return json
  }

  // ----------------------------------------------------------------------
  // APIClient.importKey() : Not Supported
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: format ["PKCS8"]
  //  ARG[2]: datab64 (key base64)
  //  ARG[3]: password
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async importKey(tokenId: string, format: string, datab64: string, passwd?: string): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.importKey():ENTER')
    }
    if (showLog) {
      console.log('APIClient.importKey():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.importKey():ARG[1]:format=' + format)
    }
    if (showLog) {
      console.log('APIClient.importKey():ARG[2]:datab64=' + datab64)
    }
    if (showLog) {
      console.log('APIClient.importKey():ARG[3]:passwd=' + passwd)
    }
    const WHERE = 'APIClient.importCert()'
    if (showLog) {
      console.log('APIClient.importKey():LEAVE')
    }
    return false
  }

  // ----------------------------------------------------------------------
  // APIClient.importCert()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: format ["X509", "PKCS7", PKCS12", "GLCK"]
  //  ARG[2]: datab64 (certificate base64)
  //  ARG[3]: password
  //  ARG[4]: importCA (list of sertificates)
  //  ARG[5]: options (any)
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async importCert(
    tokenId: string,
    format: string,
    datab64: string,
    passwd: string,
    importCA: string[],
    extractable: boolean,
    options: {}
  ): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.importCert():ENTER')
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[1]:format=' + format)
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[2]:datab64=' + datab64)
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[3]:passwd=' + Utils.toMaskedString(passwd))
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[4]:importCA=', importCA)
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[5]:extractable=', extractable)
    }
    if (showLog) {
      console.log('APIClient.importCert():ARG[6]:options=', options)
    }
    let result = false
    const WHERE = 'APIClient.importCert()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/importCert',
      parameter: {
        tokenId: tokenId,
        format: format,
        datab64: datab64,
        passwd: passwd,
        importCA: importCA,
        extractable: extractable,
        options: options
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.importCert():request=', request)
    }
    const response = await this.transmit(request)
    const json = JSON.parse(response.body)
    if (showLog) {
      console.log('APIClient.importCert():response=', json)
    }
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.importCert():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.exportCert()
  // ----------------------------------------------------------------------
  //  ARG[0]: tokenId
  //  ARG[1]: certId
  //  ARG[2]: format ["PKCS12" or "GLCK"]
  //  ARG[3]: password
  //  ARG[4]: importCA (list of serial number)
  //  RETURN: {
  //    success: boolean,
  //    error: string,
  //    pkcs12: string (base64),
  //    glck: string (base64) }
  //  }
  // ----------------------------------------------------------------------
  public async exportCert(tokenId: string, certId: string, format: string, passwd: string, importCA: string[]): Promise<any> {
    if (showLog) {
      console.log('APIClient.exportCert():ENTER')
    }
    if (showLog) {
      console.log('APIClient.exportCert():ARG[0]:tokenId=' + tokenId)
    }
    if (showLog) {
      console.log('APIClient.exportCert():ARG[1]:certId=' + certId)
    }
    if (showLog) {
      console.log('APIClient.exportCert():ARG[2]:format=' + format)
    }
    if (showLog) {
      console.log('APIClient.exportCert():ARG[3]:passwd=' + Utils.toMaskedString(passwd))
    }
    if (showLog) {
      console.log('APIClient.exportCert():ARG[5]:importCA=', importCA)
    }
    const result = { success: false, error: '', exported: '' }
    const WHERE = 'APIClient.exportCert()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/exportCert',
      parameter: {
        tokenId: tokenId,
        format: format,
        certId: certId,
        passwd: passwd,
        importCA: importCA
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.exportCert():request=', request)
    }
    const response = await this.transmit(request)
    const json = JSON.parse(response.body)
    if (showLog) {
      console.log('APIClient.exportCert():response=', json)
    }
    if (json.success) {
      result.success = true
      result.exported = json.exported
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.exportCert():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.deleteCert()
  // ----------------------------------------------------------------------
  //  ARG[0]: string (certId)
  //  RETURN: boolean
  // ----------------------------------------------------------------------
  public async deleteCert(certId: string): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.deleteCert():ENTER')
    }
    if (showLog) {
      console.log('APIClient.deleteCert():ARG[0]:certId=' + certId)
    }
    let result = false
    const WHERE = 'APIClient.deleteCert()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/deleteCert',
      parameter: {
        certId: certId
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.deleteCert():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.deleteCert():response=', response)
    }
    const json = JSON.parse(response.body)
    if (showLog) {
      console.log('APIClient.deleteCert():json=', json)
    }
    if (showLog) {
      console.log("APIClient.deleteCert():json['success']=" + json['success'])
    }
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.deleteCert():response=', response)
    }
    if (showLog) {
      console.log('APIClient.deleteCert():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // APIClient.parseFile()
  // ----------------------------------------------------------------------
  //  ARG[0]: string (licenseCode (JWS))
  //  RETURN: APIClient class
  // ----------------------------------------------------------------------
  public async parseFile(datab64: string, passwd?: string): Promise<any> {
    if (showLog) {
      console.log('APIClient.parseFile():ENTER')
    }
    if (showLog) {
      console.log('APIClient.parseFile():ARG[0]:datab64=' + datab64)
    }
    if (showLog) {
      console.log('APIClient.parseFile():ARG[1]:passwd=' + Utils.toMaskedString(passwd))
    }
    let password = ''
    if (passwd !== undefined) {
      password = passwd
    }
    const WHERE = 'APIClient.parseFile()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/parseFile',
      parameter: {
        datab64: datab64,
        password: password
      }
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.parseFile():request=', request)
    }
    const response = await this.transmit(request)
    const json = JSON.parse(response.body)
    if (json.success) {
      const certs = json.certs
      if (certs) {
        for (let i = 0; i < certs.length; i++) {
          const cert = certs[i]
          if (cert.subject) {
            const obj = JSON.parse(cert.subject)
            cert.subject = new Map(obj)
          }
          if (cert.issuer) {
            const obj = JSON.parse(cert.issuer)
            cert.issuer = new Map(obj)
          }
        }
      }
    }
    if (showLog) {
      console.log('APIClient.parseFile():response=', json)
    }
    if (showLog) {
      console.log('APIClient.parseFile():LEAVE')
    }
    return json
  }

  // ----------------------------------------------------------------------
  // APIClient.refreshTokens()
  // ----------------------------------------------------------------------
  //  ARG[0]: string (licenseCode (JWS))
  //  RETURN: APIClient class
  // ----------------------------------------------------------------------
  public async refreshTokens(): Promise<boolean> {
    if (showLog) {
      console.log('APIClient.refreshTokens():ENTER')
    }
    let result = false
    const WHERE = 'APIClient.refreshTokens()'
    const path = '/api/v1/request'
    const request = APIRequest.create('POST', this.protocol, path)
    const payload = {
      command: '/api/v1/refresh'
    }
    request.body = JSON.stringify(payload)
    if (showLog) {
      console.log('APIClient.refreshTokens():request=', request)
    }
    const response = await this.transmit(request)
    if (showLog) {
      console.log('APIClient.refreshTokens():response=', response)
    }
    const json = JSON.parse(response.body)
    if (json.success) {
      result = true
    } else {
      throw new APIException(WHERE, json.error, 1)
    }
    if (showLog) {
      console.log('APIClient.refreshTokens():LEAVE')
    }
    return result
  }

  // ----------------------------------------------------------------------
  // private: APIClient.get()
  // ----------------------------------------------------------------------
  private async get(req: APIRequest): Promise<APIResponse> {
    // if (showLog) { console.log("APIClient.get():ENTER"); }
    const WHERE = 'APIClient.get()'
    const result = new APIResponse()
    try {
      const url = req.protocol + '://' + req.host + ':' + req.port + req.path
      result.host = req.host
      result.port = req.port
      result.path = req.path
      result.method = req.method
      result.url = url
      // if (showLog) { console.log("APIClient.get():Try to connect: " + url); }
      // const httpsAgent = new https.Agent({rejectUnauthorized: false});
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          Accept: 'application/json'
        }
        // agent: httpsAgent
      })
      result.statusCode = response.status
      result.body = await response.json()
      if (!response.ok) {
        console.error('APIClient.get():ERROR:', response)
        console.error('APIClient.get():FAILURE: Could not connect to backend')
      }
    } catch (e: any) {
      console.error('APIClient.get():Caught Exception=', e)
      result.error = e.message
    }
    // if (showLog) { console.log("APIClient.get():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // private: APIClient.post()
  // ----------------------------------------------------------------------
  private async post(req: APIRequest): Promise<APIResponse> {
    // if (showLog) { console.log("APIClient.post():ENTER"); }
    const WHERE = 'APIClient.post()'
    const result = new APIResponse()
    try {
      const url = req.protocol + '://' + req.host + ':' + req.port + req.path
      result.host = req.host
      result.port = req.port
      result.path = req.path
      result.method = req.method
      result.url = url
      const json = JSON.parse(req.body)
      const body = JSON.stringify(json)
      const head: any = { 'Content-Type': 'application/json' }
      if (this.session.id.length > 0) {
        // head['Authorization'] = 'Basic ' + this.session.id;
        head['Authorization'] = this.session.id
      }
      // if (showLog) { console.log("APIClient.post():body=" + body); }
      // if (showLog) { console.log("APIClient.post():head=", head); }
      // if (showLog) { console.log("APIClient.post():Try to connect: " + url); }
      // const httpsAgent = new https.Agent({rejectUnauthorized: false});
      const response = await fetch(url, {
        method: 'post',
        mode: 'cors',
        cache: 'no-cache',
        headers: head,
        body: body
        // agent: httpsAgent
      })
      // if (showLog) { console.log("APIClient.post():response=", response); }
      // if (showLog) { console.log("APIClient.post():statusCode=", response.status); }
      result.statusCode = response.status
      if (response.ok) {
        result.body = await response.json()
      } else {
        console.error('APIClient.post():statusCode=' + response.status)
      }
    } catch (e: any) {
      // console.error("APIClient.post():Caught Exception=", e);
      result.error = e.message
    }
    // if (showLog) { console.log("APIClient.post():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // private: APIClient.execute()
  // ----------------------------------------------------------------------
  private async execute(req: APIRequest): Promise<APIResponse> {
    // if (showLog) { console.log("APIClient.execute():ENTER"); }
    const WHERE = 'APIClient.execute()'
    let result = new APIResponse()
    try {
      // if (showLog) { console.log("APIClient.execute():Method=" + req.method); }
      if (req.method === 'GET') {
        result = await this.get(req)
      }
      if (req.method === 'POST') {
        result = await this.post(req)
      }
    } catch (e: any) {
      console.error('APIClient.execute():Caught Exception=', e)
      result.error = e.message
    }
    // if (showLog) { console.log("APIClient.execute():LEAVE"); }
    return result
  }

  // ----------------------------------------------------------------------
  // private: APIClient.transmit()
  // ----------------------------------------------------------------------
  private async transmit(req: APIRequest): Promise<APIResponse> {
    // if (showLog) { console.log("APIClient.transmit():ENTER"); }
    const WHERE = 'APIClient.transmit()'
    let process = true
    let result = new APIResponse()
    try {
      if (req.method === 'POST') {
        const request = new APIRequest(req.path)
        request.method = req.method
        request.port = req.port
        request.protocol = req.protocol
        request.host = req.host
        request.command = req.command
        if (process) {
          // if (showLog) { console.log("APIClient.transmit():1) Encrypt Request Body"); }
          // console.debug("APIClient.transmit():req.command=" + req.command);
          // console.debug("APIClient.transmit():req.body=" + req.body);
          const nonce = Utils.generateRandomBase64(64)
          const envelope = new APIRequestEnvelope()
          envelope.nonce = nonce
          envelope.algorithm = 'AES256-GCM'
          const ret = await this.session.encrypt(nonce, req.body)
          if (ret.success) {
            envelope.payload = ret.encrypted // req.body;
            // console.debug("APIClient.transmit():envelope=", envelope);
            request.body = JSON.stringify(envelope)
            // console.debug("APIClient.transmit():request.body=" + request.body);
          } else {
            console.error('APIClient.transmit():Failed to encrypt')
            process = false
          }
        }
        if (process) {
          // if (showLog) { console.log("APIClient.transmit():2) Transmit Data"); }
          result = await this.post(request)
          // console.debug("APIClient.transmit():response=", result);
        }
        if (process) {
          // if (showLog) { console.log("APIClient.transmit():3) Decrypt Response"); }
          const json = JSON.parse(result.body)
          // console.trace("APIClient.transmit():json=", json);
          const response = APIResponseEnvelope.create(json)
          // console.trace("APIClient.transmit():APIResponseEnvelope=", response);
          const enc = JSON.parse(json.payload)
          // console.trace("APIClient.transmit():encrypted=", enc);
          const ret = await this.session.decrypt(enc.nonce, enc.payload)
          if (ret.success) {
            // console.trace("APIClient.transmit():decrypted=", ret.decrypted);
            result.body = ret.decrypted
            // console.trace("APIClient.transmit():decrypted=" + result.body);
          } else {
            console.error('APIClient.transmit():Failed to decrypt')
            process = false
          }
        }
      }
    } catch (e: any) {
      console.error('APIClient.transmit():Caught Exception=', e)
      result.error = e.message
    }
    // if (showLog) { console.log("APIClient.transmit():LEAVE"); }
    return result
  }
}

/**
 Below class is modified ver of https://github.com/vireshshah/custom-protocol-check
 ---------------------------------------------------------------------------
 The MIT License (MIT)

 Copyright (c) 2015 Ismail Habib Muhammad

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 ---------------------------------------------------------------------------
 */

export class CustomUrlChecker {
  private static browser = {
    getUserAgent: function () {
      return window.navigator.userAgent
    },

    userAgentContains: function (browserName: string) {
      browserName = browserName.toLowerCase()
      return this.getUserAgent().toLowerCase().indexOf(browserName) > -1
    },

    isOSX: function () {
      return this.userAgentContains('Macintosh')
    },

    isFirefox: function () {
      return this.userAgentContains('firefox')
    },

    isEdge: function () {
      const ua = this.getUserAgent().toLowerCase()

      // Test values.
      // Uncomment to check result

      // Edge
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2311.135 Safari/537.36 Edge/12.10240';

      const edge = ua.indexOf('edge')
      if (edge > 0) {
        return true
      }

      return false
    },

    isChrome: function () {
      // IE11 returns undefined for window.chrome
      // and new Opera 30 outputs true for window.chrome
      // but needs to check if window.opr is not undefined
      // and new IE Edge outputs to true for window.chrome
      // and if not iOS Chrome check
      const isChromium = (window as any).chrome
      const winNav = window.navigator
      const vendorName = winNav.vendor
      const isOpera = typeof (window as any).opr !== 'undefined'
      const isIEedge = winNav.userAgent.indexOf('Edge') > -1
      const isIOSChrome = winNav.userAgent.match('CriOS')
      return (
        (isChromium !== null &&
          typeof isChromium !== 'undefined' &&
          vendorName === 'Google Inc.' &&
          isOpera === false &&
          isIEedge === false) ||
        isIOSChrome
      )
    },

    isOpera: function () {
      return this.userAgentContains(' OPR/')
    }
  }

  private static registerEvent = (target: any, eventType: string, cb: Function) => {
    if (showLog) {
      console.log('CustomUrlChecker.registerEvent():ENTER')
    }
    if (target.addEventListener) {
      target.addEventListener(eventType, cb)
      if (showLog) {
        console.log('CustomUrlChecker.registerEvent():LEAVE')
      }
      return {
        remove: function () {
          target.removeEventListener(eventType, cb)
        }
      }
    } else {
      target.attachEvent(eventType, cb)
      if (showLog) {
        console.log('CustomUrlChecker.registerEvent():LEAVE')
      }
      return {
        remove: function () {
          target.detachEvent(eventType, cb)
        }
      }
    }
  }

  private static createHiddenIframe = (target: any, uri: string) => {
    if (showLog) {
      console.log('CustomUrlChecker.createHiddenIframe():ENTER')
    }
    const iframe = document.createElement('iframe')
    iframe.src = uri
    iframe.id = 'hiddenIframe'
    iframe.style.display = 'none'
    target.appendChild(iframe)
    if (showLog) {
      console.log('CustomUrlChecker.createHiddenIframe():LEAVE')
    }
    return iframe
  }

  private static openUriWithHiddenFrame = (uri: string, failCb: Function, successCb: Function, cbTimeout: number) => {
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithHiddenFrame():ENTER')
    }
    const timeout = setTimeout(function () {
      if (showLog) {
        console.log('CustomUrlChecker.openUriWithHiddenFrame():timeout reached')
      }
      failCb()
      handler.remove()
    }, cbTimeout)

    let iframe: any = document.querySelector('#hiddenIframe')
    if (!iframe) {
      iframe = this.createHiddenIframe(document.body, 'about:blank')
    }

    const onBlur = () => {
      if (showLog) {
        console.log('CustomUrlChecker.openUriWithHiddenFrame():onBlur triggered')
      }
      clearTimeout(timeout)
      handler.remove()
      successCb()
    }
    const handler = this.registerEvent(window, 'blur', onBlur)

    if (showLog) {
      console.log('CustomUrlChecker.openUriWithHiddenFrame():opening ' + uri)
    }
    iframe.contentWindow.location.href = uri
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithHiddenFrame():LEAVE')
    }
  }

  private static openUriWithTimeoutHack = (uri: string, failCb: Function, successCb: Function, cbTimeout: number) => {
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithTimeoutHack():ENTER')
    }
    const timeout = setTimeout(function () {
      failCb()
      handler.remove()
    }, cbTimeout)

    //handle page running in an iframe (blur must be registered with top level window)
    let target = window as any
    while (target.parent && target !== target.parent) {
      target = target.parent
    }

    const onBlur = () => {
      clearTimeout(timeout)
      handler.remove()
      successCb()
    }

    const handler = this.registerEvent(target, 'blur', onBlur)

    if (showLog) {
      console.log('CustomUrlChecker.openUriWithTimeoutHack():opening ' + uri)
    }
    window.location.href = uri
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithTimeoutHack():LEAVE')
    }
  }

  private static openUriWithMsLaunchUri = (uri: string, failCb: Function, successCb: Function) => {
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithMsLaunchUri():ENTER')
    }
    (navigator as any).msLaunchUri(uri, successCb, failCb)
    if (showLog) {
      console.log('CustomUrlChecker.openUriWithMsLaunchUri():LEAVE')
    }
  }

  public static protocolCheck = (uri: string, successCb: Function, failCb: Function, timeout = 2000) => {
    if (showLog) {
      console.log('CustomUrlChecker.protocolCheck():ENTER')
    }
    const successCallback = () => {
      successCb && successCb()
    }

    const failCallback = () => {
      failCb && failCb()
    }

    const openUri = () => {
      if (this.browser.isFirefox() || this.browser.isOSX()) {
        if (showLog) {
          console.log('CustomUrlChecker.protocolCheck():is FF = ' + this.browser.isFirefox())
        }
        if (showLog) {
          console.log('CustomUrlChecker.protocolCheck():is OSX = ' + +this.browser.isOSX())
        }
        this.openUriWithHiddenFrame(uri, failCallback, successCallback, timeout)
      } else {
        if (showLog) {
          console.log('CustomUrlChecker.protocolCheck():not FF or OSX, chrome=' + this.browser.isChrome())
        }
        // For Chrome
        this.openUriWithTimeoutHack(uri, failCallback, successCallback, timeout)
      }
    }

    if (this.browser.isEdge()) {
      if (showLog) {
        console.log('CustomUrlChecker.protocolCheck():is Edge')
      }
      //for Edge
      this.openUriWithMsLaunchUri(uri, failCb, successCb)
    } else {
      if (document.hasFocus()) {
        if (showLog) {
          console.log('CustomUrlChecker.protocolCheck():has focus')
        }
        openUri()
      } else {
        const focusHandler = this.registerEvent(window, 'focus', () => {
          focusHandler.remove()
          openUri()
        })
      }
    }
    if (showLog) {
      console.log('CustomUrlChecker.protocolCheck():LEAVE')
    }
  }

  public static openProtocol = async (uri: string, timeoutMs: number = 2000) => {
    if (showLog) {
      console.log('CustomUrlChecker.openProtocol():ENTER')
    }
    let result = false
    try {
      const res = await (async () => {
        return new Promise((resolve, reject) => {
          this.protocolCheck(
            uri,
            (successCb: Function) => {
              if (showLog) {
                console.log('CustomUrlChecker.openProtocol():calling successCb')
              }
              resolve(successCb)
            },
            (failCb: Function) => {
              if (showLog) {
                console.log('CustomUrlChecker.openProtocol():calling failCb')
              }
              reject(failCb)
            },
            timeoutMs
          )
        })
      })()
      if (showLog) {
        console.log(res)
      }
      result = true
    } catch (e) {
      result = false
    }
    if (showLog) {
      console.log('CustomUrlChecker.openProtocol():LEAVE')
    }
    return result
  }
}
